import type { Settings } from './schema'
import { createStore } from 'zustand'
import type { FeatureFlag } from './feature-flags'

type SettingsStore = {
  settings: Settings | null

  setSettings: (settings: Settings) => void
  clearSettings: () => void
  userHasFlag: (flag: FeatureFlag) => boolean
}

export const settingsStore = createStore<SettingsStore>((set, get) => ({
  settings: getStoredSettings(),

  setSettings: (settings: Settings) => set({ settings }),
  userHasFlag: (flag: FeatureFlag) => !!get().settings?.flags?.includes(flag),
  clearSettings: () => set({ settings: null }),
}))

// Save changes to the store to localStorage
settingsStore.subscribe(state => {
  const settings = state.settings ?? {}
  localStorage.setItem('settings-storage', JSON.stringify({ ...settings }))
})

// Get stored settings from localStorage if available
function getStoredSettings(): Settings | null {
  try {
    const storedData = localStorage.getItem('settings-storage')
    if (!storedData) return null

    const parsedData = JSON.parse(storedData)
    return parsedData || null
  } catch (error) {
    console.error('Failed to parse stored settings:', error)
    return null
  }
}
